import React from 'react';
import SvgBitPayLogo from "../../assets/svg/bitpay-logo";
import styled from 'styled-components'

const PositionedLogo = styled.div`{
  position: absolute;
  top: 20px;
  left: 20px;
}`;

const Masthead = () => {

  return (
    <PositionedLogo>
      <a href={'/'} aria-label="navigate to BitPay home page">
        <SvgBitPayLogo/>
      </a>
    </PositionedLogo>
  );
};

export default Masthead;
